<template>
    <CicPopup class="no-padding" title="Media Upload Results" @blur="$emit('blur')">
        <div id="media_upload_general_status" style="padding: 10px">
            {{ $t('MEDIA_UPLOAD_GENERALSTATUS_' + errorCode) }}
        </div>
        <table class="cic-table">
            <thead>
                <tr>
                    <th style="width: 40px"></th>
                    <th>{{ $t('Media') }}</th>
                    <th>{{ $t('Media Type') }}</th>
                    <th>{{ $t('Media Overridden') }}</th>
                    <th>{{ $t('Upload Status') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in media">
                    <td :class="'media-icon media-icon-' + row.type"></td>
                    <td>{{ row.name }}</td>
                    <td>{{ $t('MEDIA_TYPE_' + row.type) }}</td>
                    <td>{{ row.overwritten ? $t('MEDIA_OVERRIDDEN_YES') : $t('MEDIA_OVERRIDDEN_NO') }}</td>
                    <td>{{ $t('MEDIA_UPLOAD_STATUS_' + row.status) }}</td>
                </tr>
            </tbody>
        </table>
        <template #footer>
            <CicButton id="popup_back" @click="$emit('back')">
                {{ $t('Back') }}
            </CicButton>
        </template>
    </CicPopup>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicPopup from '@/components/CicPopup';

    export default {
        name: 'UploadResults',
        components: {
            CicButton,
            CicPopup,
        },
        props: {
            errorCode: {
                type: String,
                required: true,
            },
            media: {
                type: Array,
                required: true,
            },
        },
        emits: ['back', 'blur'],
    };
</script>
